import { useMemoizedFn } from 'ahooks';
import overseaTranslateReport, { TranslateReportV2Body } from 'services/api/overseaTranslateReport';
import { ReportTask } from './reportTask';
import {
  commonTransReport,
  CommonTransReportParams,
  returnReasonTransReport,
  ReturnReasonTransReportParams,
  ReviewTransReportBody,
  reviewTransReport,
} from 'services/api/conversation';

/**
 * 翻译上报的模块
 */
type TranslateReportModule =
  /**
   * 消息
   */
  | 'Message'
  /**
   * 退款原因
   */
  | 'ReturnReason'
  /**
   * 评价
   */
  | 'Review'
  /**
   * 通用
   */
  | 'Common';

const messageReportTask = new ReportTask({
  request: overseaTranslateReport,
});
const returnReasonReportTask = new ReportTask({
  request: returnReasonTransReport,
});
const reviewReportTask = new ReportTask({
  request: reviewTransReport,
});

const commonReportTask = new ReportTask({
  request: commonTransReport,
});

type RunBody =
  | TranslateReportV2Body
  | ReturnReasonTransReportParams
  | CommonTransReportParams
  | ReviewTransReportBody;

export const useTranslateReport = () => {
  const run = useMemoizedFn((body: RunBody, type: TranslateReportModule) => {
    return new Promise((resolve) => {
      switch (type) {
        case 'Message': {
          messageReportTask.run({
            body: body as TranslateReportV2Body,
            resolve,
          });
          break;
        }
        case 'ReturnReason': {
          returnReasonReportTask.run({
            body: body as ReturnReasonTransReportParams,
            resolve,
          });
          break;
        }
        case 'Review': {
          reviewReportTask.run({
            body: body as ReviewTransReportBody,
            resolve,
          });
          break;
        }
        case 'Common': {
          commonReportTask.run({
            body: body as CommonTransReportParams,
            resolve,
          });
          break;
        }
        default: {
          resolve(false);
          break;
        }
      }
    });
  });

  return run;
};
